// import createLogger from 'redux-logger'
import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './reducer'
import rootSaga from './saga'
import createSagaMiddleware from 'redux-saga'
import Raven from 'raven-js'
import createRavenMiddleware from 'raven-for-redux'

Raven.config('https://d279149dd8af49da884e4f3b9872beab@sentry.io/1301160', {
  environment: process.env.ENV,
  shouldSendCallback: data => {
    if (process.env.NODE_ENV === 'development') { return false }
    // Needed to exclude academy exceptions when bot is embedded,
    // academy's transaction string is different
    return data.transaction && data.transaction.includes('/static/js/main.js')
  }
}).install()

let store

function configureStore(initialState) {
  // const loggerMiddleware = createLogger()

  const sagaMiddleware = createSagaMiddleware({
    onError: error => (Raven.captureException(error))
  })

  store = createStore(rootReducer, initialState, compose(
    applyMiddleware(sagaMiddleware,  createRavenMiddleware(Raven)),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f => f),
  ))

  sagaMiddleware.run(rootSaga)

  return store
}

export {
  store,
  configureStore,
}



// WEBPACK FOOTER //
// ./src/store/index.js